import React, { FunctionComponent } from "react";

export function priceFormatter(price: number): string {
	return `$${String(price).replace(/(.{2})$/, ".$1")}`;
}

export const Price: FunctionComponent<{ value: number }> = ({ value }) => (
	<>{priceFormatter(value)}</>
);
